import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { StaffingCategories } from "./components/StaffingCategories";
import { AboutUs } from "./components/AboutUs";
import { Services } from "./components/Services";
import { WhyChooseUs } from "./components/WhyChooseUs";
import { Testimonials } from "./components/Testimonials";
import { ClientTestimonials } from "./components/ClientTestimonials";
import { FAQ } from "./components/FAQ";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { CookieConsent } from "./components/CookieConsent";
import { ChatSupport } from "./components/ChatSupport";
import { CareersPage } from "./pages/CareersPage";
import { AboutPage } from "./pages/AboutPage";
import { FindTalentPage } from "./pages/FindTalentPage";
import { ApplyNowPage } from "./pages/ApplyNowPage";
import { PrivacyPolicyPage } from "./pages/PrivacyPolicyPage";
import { TermsOfServicePage } from "./pages/TermsOfServicePage";
import { CookiePolicyPage } from "./pages/CookiePolicyPage";
import { LogoOptionsPage } from "./pages/LogoOptionsPage";
import { CredentialTrackerPage } from "./pages/CredentialTrackerPage";
import { InterviewPrepPage } from "./pages/InterviewPrepPage";
import { DemandForecastPage } from "./pages/DemandForecastPage";
import { AuthPage } from "./pages/AuthPage";
import { ResetPasswordPage } from "./pages/ResetPasswordPage";
import { AdminPanelPage } from "./pages/AdminPanelPage";
import { AuthProvider } from "./context/AuthContext";
import { usePageMeta } from "./hooks/usePageMeta";
import { useHomeStructuredData, useServiceStructuredData } from "./hooks/useStructuredData";

const HomePage = () => {
  usePageMeta({
    title: null,
    description: 'Digitive Health connects qualified nursing, allied health, and non-clinical professionals with healthcare facilities nationwide. Travel staffing, direct hire, managed services, and more.',
    path: '/',
  });
  useHomeStructuredData();
  useServiceStructuredData();

  return (
    <>
      <Header />
      <main>
        <Hero />
        <StaffingCategories />
        <AboutUs />
        <Services />
        <WhyChooseUs />
        <Testimonials />
        <ClientTestimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App" data-testid="app-container">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/find-talent" element={<FindTalentPage />} />
            <Route path="/apply-now" element={<ApplyNowPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-of-service" element={<TermsOfServicePage />} />
            <Route path="/cookie-policy" element={<CookiePolicyPage />} />
            <Route path="/logo-options" element={<LogoOptionsPage />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/tools/credentials" element={<CredentialTrackerPage />} />
            <Route path="/tools/interview-prep" element={<InterviewPrepPage />} />
            <Route path="/tools/demand-forecast" element={<DemandForecastPage />} />
            <Route path="/dh-admin-panel" element={<AdminPanelPage />} />
          </Routes>
          <CookieConsent />
          <ChatSupport />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
